import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { ElementType } from '../../common/enum/elementType';
import { ValidateMessage, ValidationResultItem } from '../../component/validation/IValidation';
import ErrorMessageElement from '../error/ErrorMessageElement';
import { SimpleValue, SimpleValueList, JSONObject, JSONObjectList } from '../../interface/IDefine';
import { ValidationError } from '../../util/validate';
import { InputProps } from '../../common/types/props';
import { InputDefines } from '../../common/types/defines';

import "./InputElement.scss";

interface ElementCore {
  type: ElementType;
  value: SimpleValue | SimpleValueList | JSONObject | JSONObjectList | { [key: string]: any };
  valid?: ValidationResultItem;
  dispatchValid: (valid: ValidateMessage) => void;
  touched: boolean;
  composing?: boolean;
  overrideErrorMessage?: ValidationError[];

  props: InputProps;
  defines: InputDefines;

  children: JSX.Element;
}

const InputElement = (props: ElementCore) => {
  const [error, setError] = useState<ValidationError[]>([]);
  const [errorMessageHeight, setErrorMessageHeight] = useState<number>(0);

  const enable = useMemo(() => {
    return props.touched && (typeof props.defines.hideInvalidMessage === "boolean" ?
      !props.defines.hideInvalidMessage : !props.props.hideInvalidMessage);
  }, [props?.defines?.hideInvalidMessage, props?.props?.hideInvalidMessage, props.touched]);

  const label = useMemo(() => {
     return { value: props.defines.label, enable: props.defines.displayLabel };
  }, [props?.defines?.label, props.defines?.displayLabel]);

  useEffect(() => {
    if (!props.dispatchValid || props.composing) return;
    props.dispatchValid({
      type: props.defines.type,
      name: props.defines?.name,
      value: props.value,
      valid: props.valid,
      validations: props.defines?.validate,
      label: props.defines?.hiddenErrorPrefixLabel ? undefined : label.value,
      error: setError
    } as ValidateMessage)
  }, [props.value, props.composing]);

  return (
    <div className={props.type + " form-container" + (props.defines?.required ? " required" : "")} style={{
      transition: "margin-bottom .3s ease",
      marginBottom: error.length > 0 ? errorMessageHeight : 0
    }}>
      {label.value && label.enable &&
        <label className="form-label">{label.value}{
          props.defines?.required && <span className="required">{props.props?.option?.requiredText || "※ 必須"}</span>
        }</label>
      }
      {props.children}
      {enable &&
        <ErrorMessageElement
          messages={props.overrideErrorMessage && props.overrideErrorMessage.length > 0 ?
            props.overrideErrorMessage : error}
          setErrorMessageBoxHeight={setErrorMessageHeight}
        ></ErrorMessageElement>
      }
    </div>
  )
};

export default InputElement;
